<template>
  <div style="width: 100%; height: 100%;"
    :style="{ animation: option.attribute.autoRotate ? 'rotate ' + option.attribute.rotateDuration + 's infinite linear' : null }"
    @click.stop="clickHandler">
    <t-image v-if="!option.attribute.isPreview" style="width: 100%; height: 100%;z-index:0"
      :style="{ background: option.attribute.bgColor || 'none', opacity: option.attribute.opacity }"
      :src="url ? url : fileUrl + option.attribute.url" :fit="option.attribute.fit" :loading="option.attribute.isTabGroupId && ''" />

    <t-image-viewer v-else :fit="option.attribute.fit" :images="[imgUrl]" style="width: 100%; height: 100%;z-index:0"
      :style="{ background: option.attribute.bgColor || 'none' }">
      <template #trigger="{ open }">
        <div class="tdesign-demo-image-viewer__ui-image">
          <img alt="test" :src="imgUrl" class="tdesign-demo-image-viewer__ui-image--img" />
          <div class="tdesign-demo-image-viewer__ui-image--hover" @click="open">
            <span>
              <BrowseIcon size="1.4em" /> 预览
            </span>
          </div>
        </div>
      </template>
    </t-image-viewer>
  </div>
</template>

<script>
import { fileUrl } from '/env'
import { BrowseIcon } from 'tdesign-icons-vue-next';

import { FuncEvents,Login } from '@/utils/functionEvent'
import { MessagePlugin } from 'tdesign-vue-next';
import { getResByDatasetIdApi } from "@/api/dataset/dataset";
import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
// import cptTextOption from "@/components/element/attrs/cpt-text-option";
import {
  LoginArrId,
} from "@/utils/func";
export default {
  name: "cpt-image",
  props: { option: Object, current: Object, components: Array, componentLevel: Number, refMap: Object },
  components: { BrowseIcon } ,
  data() {
    return {
      fileUrl,
      cptData: [],
      url: '',
      newData: "",
      jsFunFlag: false,
    }
  },
  watch: {
    // 'option.attribute.url': {
    //   handler(obj) {
    //      this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
    //   },
    //   deep: true,
    // },
  "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    //mark:合并属性，由于属性字段更新，导致旧版本数据不能正常渲染组件或配置表单，所有组件都应执行这项操作！！！
    // const temp = JSON.parse(JSON.stringify(cptTextOption.attribute))
    // this.option.attribute = Object.assign({}, temp, this.option.attribute);
    if (this.option.cptDataForm && !this.option.cptDataForm.pollTime) {
      this.option.cptDataForm.pollTime = 0
    }
    if(!this.option.attribute.noQuery || this.dataReload.includes(0)){
      this.refreshCptData();
    }

    if (!this.option.attribute.hasOwnProperty("isPreview")) {
      this.option.attribute.isPreview = false
    }
  },
  computed: {
    imgUrl() {
      return this.url ? this.url : this.fileUrl + this.option.attribute.url
    },
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  mounted() {
    // console.log(this.current,111111)
    if (!this.option.attribute.zIndex && typeof this.componentLevel == "number") {
      this.option.attribute.zIndex = this.componentLevel
    }
    if (this.option.cptDataForm && !this.option.cptDataForm.hasOwnProperty('isCache')) {
      this.option.cptDataForm['isCache'] = false
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        const defaultValue = getDefaultValue(this.option.attribute)
        if (defaultValue) {
          this.cptData.value = defaultValue
        } else {
          this.loadData(cptDataForm, paras)
        }
      }, this.components)
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag)
      })
    },

    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      console.log(cptDataForm, res, 'cptDataForm5656')
      // 第一层判断 如果选择数据集
      if (cptDataForm && cptDataForm.dataSource == '4') {
        if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid' && !this.refMap[this.current.cptOption.interaction.fatherGridId]?.current.cptOption.attribute.isPop) return
        console.log(cptDataForm, res, 'cptDataForm5656777')
        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) { // 没有全部配置映射字段
          //判断此控件在九宫格里面就不请求数据
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
            let newres = [];
            let newObj = { ...res[0] };
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
            if (dataKey[0].value && newObj[dataKey[0].value]) {
              newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            }
            newres.push(newObj);
            console.log(newres, '新数组');
            this.cptData = newres[0];
            this.url = this.cptData[this.option.attribute.cptTableData[0].value]
            console.log(this.url, '6786787667')
          }

        } else { // 如果配置了转换脚本
          this.cptData = res;
        }
      } else { // 不是数据集类型，是静态数据
        // console.log(res,'图片');
        this.cptData = res;
        this.url = res?.url
      }
      const attr = this.option.attribute
      if (attr.alarmConfig && attr.alarmConfig.threshold) {//告警判断
        that.alarmed = compareByOperator(attr.alarmConfig.operator, that.cptData.value, attr.alarmConfig.threshold)
      }

      console.log(this.url, 'asdasidjaijdsiaijdaijdjiasijdaijd')
    },
    clickHandler(e) {
      console.log(LoginArrId,'LoginArrIdLoginArrIdLoginArrId');
      if(LoginArrId.includes(this.current.id)){//需要登录,需要用户地址
         console.log('检查用户是否登录')
        let isLogin = FuncEvents.getUserId()
        if(!isLogin){
          return
        }
        console.log('已经登录')
        // MessagePlugin.warning('暂无地址，请新增默认地址');
        // getResByDatasetIdApi('aa1f903fe35b194dbdfe725256ef27bb','sql',{userId :isLogin}).then(res => {
        //   if (res.code == 200) {
            
        //     const result = JSON.parse(res.data.apiRes)
        //     if(result.length > 0){
        //       console.log('有默认收货地址')
        //       this.$emit('clickHandler', this.option.interaction, {
        //         default: this.current,
        //         event: e,
        //         current: this.current,
        //       })
        //     }else{
        //       console.log('没有默认收货地址')
        //       Login.goToWXPage({ url: '/pages/xd-yytPage/childrenDpPage/dp_index_6?url=https://www.xdwater365.com:6883/v/c07f44cf3bc5e403347dc47a1c6d0d67' })
        //     }
        //   }
        // })
        this.$emit('clickHandler', this.option.interaction, {
          default: this.current,
          event: e,
          current: this.current,
        })
      }else{
        this.$emit('clickHandler', this.option.interaction, {
          default: this.current,
          event: e,
          current: this.current,
        })
      }

      
    },
    setValue(value) {
      this.url = value
    },
    getValue() {
      if (this.url) {
        return this.url
      } else {
        return this.fileUrl + this.option.attribute.url
      }
    }
  },
}
</script>



<style>
@keyframes rotate {
  to {
    transform: rotate(360deg)
  }
}

.tdesign-demo-image-viewer__ui-image {
  width: 100%;
  height: 100%;
  display: inline-flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: var(--td-radius-small);
  overflow: hidden;
}

.tdesign-demo-image-viewer__ui-image--hover {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: var(--td-text-color-anti);
  line-height: 22px;
  transition: 0.2s;
}

.tdesign-demo-image-viewer__ui-image:hover .tdesign-demo-image-viewer__ui-image--hover {
  opacity: 1;
  cursor: pointer;
}

.tdesign-demo-image-viewer__ui-image--img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
  position: absolute;
}

.tdesign-demo-image-viewer__ui-image--footer {
  padding: 0 16px;
  height: 56px;
  width: 100%;
  line-height: 56px;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  color: var(--td-text-color-anti);
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  display: flex;
  box-sizing: border-box;
}

.tdesign-demo-image-viewer__ui-image--title {
  flex: 1;
}

.tdesign-demo-popup__reference {
  margin-left: 16px;
}

.tdesign-demo-image-viewer__ui-image--icons .tdesign-demo-icon {
  cursor: pointer;
}

.tdesign-demo-image-viewer__base {
  width: 160px;
  height: 160px;
  margin: 10px;
  border: 4px solid var(--td-bg-color-secondarycontainer);
  border-radius: var(--td-radius-medium);
}
</style>
